export const GOP = '#f27e7d';
export const GOP_DARK = '#f9c1c1';
export const DEMOCRAT = '#5788b8';
export const DEMOCRAT_DARK = '#abc3db';
export const GREEN = '#7BC8AF';
export const LIBERTARIAN = '#EDDB80';
export const OTHER = '#BCB1CB';
export const NEUTRAL = '#E7E7E7';
export const TIE = '#666666';

const colorLookup = new Map([
  ['gop', GOP],
  ['dem', DEMOCRAT],
  ['gre', GREEN],
  ['lib', LIBERTARIAN],
]);

export function getColor(party: string) {
  return colorLookup.get(party) || OTHER;
}

const hatchFillCache = new Map();

export function createHatchFill(fillStyle: string) {
  if (hatchFillCache.has(fillStyle)) {
    return hatchFillCache.get(fillStyle);
  }

  const patternSize = 7;
  const divisions = 4;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
  const dpi = window.devicePixelRatio || 1;

  ctx.scale(dpi, dpi);

  canvas.width = patternSize;
  canvas.height = patternSize;

  if (fillStyle === GOP) {
    ctx.fillStyle = GOP_DARK;
    ctx.fillRect(0, 0, patternSize, patternSize);
  }

  if (fillStyle === DEMOCRAT) {
    ctx.fillStyle = DEMOCRAT_DARK;
    ctx.fillRect(0, 0, patternSize, patternSize);
  }

  ctx.fillStyle = fillStyle;

  // Top line
  ctx.beginPath();
  ctx.moveTo(0, patternSize * (1 / divisions));
  ctx.lineTo(patternSize * (1 / divisions), 0);
  ctx.lineTo(0, 0);
  ctx.lineTo(0, patternSize * (1 / divisions));
  ctx.fill();
  ctx.closePath();

  // Middle line
  ctx.beginPath();
  ctx.moveTo(patternSize, patternSize * (1 / divisions));
  ctx.lineTo(patternSize * (1 / divisions), patternSize);
  ctx.lineTo(0, patternSize);
  ctx.lineTo(0, patternSize * ((divisions - 1) / divisions));
  ctx.lineTo(patternSize * ((divisions - 1) / divisions), 0);
  ctx.lineTo(patternSize, 0);
  ctx.lineTo(patternSize, patternSize * (1 / divisions));
  ctx.fill();
  ctx.closePath();

  // Bottom line
  ctx.beginPath();
  ctx.moveTo(patternSize, patternSize * ((divisions - 1) / divisions));
  ctx.lineTo(patternSize * ((divisions - 1) / divisions), patternSize);
  ctx.lineTo(patternSize, patternSize);
  ctx.lineTo(patternSize, patternSize * ((divisions - 1) / divisions));
  ctx.fill();
  ctx.closePath();

  const pattern = ctx.createPattern(canvas, 'repeat') as CanvasPattern;

  hatchFillCache.set(fillStyle, pattern);
  return pattern;
}
